import {JsonProperty} from '@dhkatz/json-ts';
import {RasterLevelResponse} from '../levels/raster-level-response';
import {AbstractSingleLayerResponse} from './abstracts/abstract-single-layer-response';

export class RasterLayerResponse extends AbstractSingleLayerResponse {

  @JsonProperty('pl')
  private _preLoading: boolean;

  @JsonProperty({name: 'd', type: RasterLevelResponse})
  private _details: RasterLevelResponse[];

  public constructor() {
    super();
    this._preLoading = undefined;
    this._details = undefined;
  }

  public get preLoading(): boolean {
    return this._preLoading;
  }

  public get details(): RasterLevelResponse[] {
    return this._details;
  }

  public set details(value: RasterLevelResponse[]) {
    this._details = value;
  }
}
